exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-fa0568de]{\n    margin-right: 25%;\n    margin-left: 25%;\n    margin-top: 55px;\n    text-align:center;\n}\n.field[data-v-fa0568de]{\n    padding:10px;\n    text-align:center;\n}\n.textlabel[data-v-fa0568de]{\n    white-space:nowrap;\n    color:#35495E;\n}\n.textfield[data-v-fa0568de]{\n    width:100%;\n}\n.title[data-v-fa0568de]{\n    font-size:30px;\n    font-weight:bold;\n    color:#35495E;\n}\n.smalltext[data-v-fa0568de]{\n    font-size: 12px;\n\tcolor: #888888;\n}\n.upload-box[data-v-fa0568de]{\n    width:75%;\n}\n.custom-file-input ~ .custom-file-label[data-v-fa0568de]::after {\n  content: 'sh';\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fa0568de","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/add/Add_Pictures.vue
// module id = 641
// module chunks = 0